import React, { useState, useEffect } from 'react';
import Bubble from './Bubble';

const BubbleMarker = ({ data }) => {
  const { currentGoalState } = data || "";
  const { relatedData } = data || "";
  const iconType = relatedData?.bubble?.iconType || "Child";

  return (
    <div className="bubble-marker__bubble">
      <div className="bubble-marker__inner">
        <div className="bubble-marker__icon">
          <Bubble icon={iconType} />
        </div>

        <div className="bubble-marker__stat">
          {currentGoalState}
        </div>
      </div>
    </div>
  );
};

export default BubbleMarker;
